<template>
    <sa-page-layout :btnConfigurazioniVisible="true" :linkConfigurazioni="linkConfigurazioni" :btnRefreshVisible="true"
        :showModalLoading="showModalLoading" :pathResource="pathResource" titoloVisible @refresh="onRefresh">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
                @click="onClickNuovoGruppo">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Nome</label>
                        <b-form-input v-model="filtro.nome" type="search"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Descrizione</label>
                        <b-form-input v-model="filtro.descrizione" type="search"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
                        class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{
                            this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <accettazione-ssn-gruppi-config-list-component ref="cmpAccettazioneSsnGruppiConfigList"
                @afterLoadData="onAfterLoadData" @editGruppo="onEdit"></accettazione-ssn-gruppi-config-list-component>
            <accettazione-ssn-gruppi-config-edit-modal ref="mdlAccettazioneSsnGruppiConfigEdit"
                @afterSave="onAfterSaveMdlGruppi" @beforeSave="onBeforeSaveMdlGruppi" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import AccettazioneSsnGruppiConfigListComponent from "../components/AccettazioneSsnGruppiConfigListComponent.vue";
import AccettazioneSsnGruppiConfigEditModal from "../components/AccettazioneSsnGruppiConfigEditModal.vue";

export default {
    mixins: [UtilityMixin],
    components: { SaPageLayout, AccettazioneSsnGruppiConfigListComponent, AccettazioneSsnGruppiConfigEditModal },
    data() {
        return {
            showModalLoading: false,
            linkConfigurazioni: "/configurazioneaccettazione",
            pathResource: "/accettazionessngruppi",
            filtro: { nome: null, descrizione: null },
        };
    },
    mounted() {
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroAccettazioneSsnGruppi"]) {
            this.filtro = JSON.parse(sessionStorage["filtroAccettazioneSsnGruppi"]);
        }
        this.loadData();
    },
    methods: {
        loadData() {
            this.$refs.cmpAccettazioneSsnGruppiConfigList.loadData();
        },
        onRefresh() {
            this.loadData();
        },
        salvaFiltro() {
            window.sessionStorage["filtroAccettazioneSsnGruppi"] = JSON.stringify(this.filtro);
        },
        onSubmit() {
            this.salvaFiltro();
            this.loadData();
        },
        onReset() {
            this.filtro = { nome: null, descrizione: null };
            this.salvaFiltro();
            this.loadData();
        },
        onEdit(item) {
            this.$refs.mdlAccettazioneSsnGruppiConfigEdit.show(item);
        },
        onClickNuovoGruppo() {
            this.$refs.mdlAccettazioneSsnGruppiConfigEdit.show(null);
        },
        onAfterLoadData() {
            this.closeShowModalLoading();
        },
        onAfterSaveMdlGruppi() {
            this.loadData();
        },
        onBeforeSaveMdlGruppi() { },
    },
};
</script>

<style></style>
